import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { S as SheetClose, C as CloseButton } from './Sheet.styles-e1be9e70.js';
import { u as useTaktId } from '../TaktIdContext/TaktIdContext-189dc982.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-12ae0974.js';
import { I as Icon } from '../Icon/Icon-0938d6c4.js';
import { t as times } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-1702ffd3-fa72660f.js';

const CloseButtonSection = ({
  onClose,
  closeRef,
  closeButtonProps,
  closeButton,
  side = 'bottom'
}) => {
  const {
    getDataTaktAttributes
  } = useTaktId(closeButtonProps === null || closeButtonProps === void 0 ? void 0 : closeButtonProps.taktId, createStormTaktId('close-button'));
  return /*#__PURE__*/React__default.createElement(SheetClose, null, /*#__PURE__*/React__default.createElement(CloseButton, _extends({
    tabIndex: 0,
    onClick: onClose,
    "aria-label": closeButton.label,
    ref: closeRef,
    type: "button",
    side: side
  }, getDataTaktAttributes({
    taktValue: closeButtonProps === null || closeButtonProps === void 0 ? void 0 : closeButtonProps.taktValue
  }), closeButtonProps), closeButton.type === 'icon' ? /*#__PURE__*/React__default.createElement(Icon, {
    type: times,
    size: "lg"
  }) : closeButton.label));
};
CloseButtonSection.defaultProps = {
  onClose: undefined,
  closeButtonProps: undefined,
  side: 'bottom'
};

export { CloseButtonSection as C };
//# sourceMappingURL=CloseButtonSection-afcdb705.js.map
